import { Host } from "./host.model";

export class Accomodation{
    /*
    *
    */
   constructor(
        public id?: number,
        public name?: string,
        public fullAddress?: string,
        public latitude?: number,
        public longitude?: number,
        public qrCodeImg?: string,
        public active?: boolean,
        public creationDate?: Date,
        public updateDate?: Date,
        public logo?: string,
        public imgMobile?: string,
        public imgDesktop?: string,
        public qrCodeId?: string,
        public lastVisitDate?: Date,
        public host?: Host
    ){}
}